import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const neutral400: string = ui.neutral[400];

const white50 = ui.white[50];

export const editorWrapper: CSSObject = {
  '.tiptap.ProseMirror[contenteditable="true"]': {
    backgroundColor: white50,
    borderRadius: "4px",
    maxHeight: "400px",
    minHeight: "140px",
    overflowY: "auto",
    padding: "0 16px",
  },
  borderRadius: "4px",
  boxShadow: `0px 0px 0 1px ${neutral400}`,
  ".tiptap p.is-editor-empty:first-child::before": {
    color: neutral400,
    content: "attr(data-placeholder)",
    float: "left",
    height: "0",
    pointerEvents: "none",
  },
};
